var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgPaintBrush = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "21px",
  height: "21px",
  viewBox: "0 0 21 21",
  xmlns: "http://www.w3.org/2000/svg",
  className: "react-svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("polygon", {
  fill: "currentColor",
  points: "4 12 17 12 17 20 13.9411765 20 14 15 12 20 4 20"
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "currentColor",
  points: "4 8 9.47368421 6 11.5263158 6 17 8 17 11 4 11"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10,1 L11,1 C11.5522847,1 12,1.44771525 12,2 L12,6 C12,6.55228475 11.5522847,7 11,7 L10,7 C9.44771525,7 9,6.55228475 9,6 L9,2 C9,1.44771525 9.44771525,1 10,1 Z M10.5,3 C10.7761424,3 11,2.77614237 11,2.5 C11,2.22385763 10.7761424,2 10.5,2 C10.2238576,2 10,2.22385763 10,2.5 C10,2.77614237 10.2238576,3 10.5,3 Z",
  fill: "currentColor"
}))));
export default SvgPaintBrush;